import React from 'react';

import styles from './Radio.module.css';

const Radio = ({ id, checked, onChange, text, className, value, name = '' }) => (
  <div className={`${styles.radio} ${className}`}>
    <input
      id={id}
      type="radio"
      checked={checked}
      onChange={onChange}
      name={name}
      value={value}
    />
    <label htmlFor={id}>{text}</label>
  </div>
);

Radio.defaultProps = {
  text: '',
  className: '',
};

export default Radio;
